import { Email, LocationOn, Phone } from '@mui/icons-material';
import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    Container,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';

const ContactScreen: React.FC = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        message: ''
    });
    const [showSuccess, setShowSuccess] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Handle form submission here
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 5000);
    };

    return (
        <Container maxWidth="lg" sx={{ py: 8 }}>
            <Typography
                variant="h2"
                component="h1"
                textAlign="center"
                gutterBottom
                sx={{ fontWeight: 'bold', mb: 2 }}
            >
                Contact Us
            </Typography>
            <Typography
                variant="h6"
                textAlign="center"
                sx={{ mb: 8, color: 'text.secondary' }}
            >
                Ready to transform your business? Let's start the conversation.
            </Typography>

            <Grid container spacing={6}>
                <Grid size={{ xs: 12, md: 8 }}>
                    <Card elevation={3}>
                        <CardContent sx={{ p: 4 }}>
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                                Send us a Message
                            </Typography>

                            {showSuccess && (
                                <Alert severity="success" sx={{ mb: 3 }}>
                                    Thank you for your message! We'll get back to you soon.
                                </Alert>
                            )}

                            <Box component="form" onSubmit={handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField
                                            fullWidth
                                            label="Full Name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <TextField
                                            fullWidth
                                            label="Email"
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            fullWidth
                                            label="Company"
                                            name="company"
                                            value={formData.company}
                                            onChange={handleChange}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            fullWidth
                                            label="Message"
                                            name="message"
                                            multiline
                                            rows={4}
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="large"
                                            sx={{
                                                backgroundColor: '#1565c0',
                                                px: 4,
                                                py: 1.5,
                                                fontSize: '1.1rem',
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                            }}
                                        >
                                            Send Message
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>
                    <Box sx={{ mb: 4 }}>
                        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Get in Touch
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
                            We're here to help you achieve your business goals.
                        </Typography>
                    </Box>

                    <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
                        <Email sx={{ mr: 2, color: '#1565c0' }} />
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Email
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                info@apexconsulting.com
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
                        <Phone sx={{ mr: 2, color: '#1565c0' }} />
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Phone
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                (555) 123-4567
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
                        <LocationOn sx={{ mr: 2, color: '#1565c0' }} />
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Office
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                123 Business Ave<br />
                                Suite 456<br />
                                New York, NY 10001
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ContactScreen;